<template>
  <div class="flex justify-center items-center w-inherit pb-8 mt-20">
    <div class="flex flex-col justify-center items-center w-full md:mx-2">
      <thread-create-form
        v-if="$auth.user().verified"
      ></thread-create-form>
      <div v-else class="text-yellow-8">You cannot create a thread because your email address has not been verified.</div>
    </div>
    <portal to="breadcrumb-portal">
      <breadcrumbs v-if="channel">
        <router-link class="breadcrumb-link" :to="{name: 'channels.index'}">Home</router-link>
        <chevron-right-icon class="mx-1"></chevron-right-icon>
        <span class="breadcrumb-item">{{ category.name }}</span>
        <chevron-right-icon class="mx-1"></chevron-right-icon>
        <router-link
          class="breadcrumb-link"
          :to="{name: 'channels.show', params: { channel: channel.slug }}"
        >{{ channel.name }}</router-link>
        <chevron-right-icon class="mx-1"></chevron-right-icon>
        <span class="breadcrumb-current">New Thread</span>
      </breadcrumbs>
    </portal>
  </div>
</template>

<script>
import ThreadCreateForm from "@/components/Forms/ThreadCreateForm.vue"
import { ChevronRightIcon } from "vue-feather-icons"
import { mapGetters } from "vuex"
import { find } from "lodash"

export default {
  name: "ThreadCreate",
  components: {
    ThreadCreateForm,
    ChevronRightIcon
  },
  computed: {
    ...mapGetters({
      categories: "categories/list"
    }),
    category() {
      return find(this.categories, ["slug", this.$route.params.category])
    },
    channel() {
      if (!this.category) return null
      return find(this.category.channels, ["slug", this.$route.params.channel])
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
